var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "l-bg-white" }, [
      _c("div", { staticClass: "row bg-grey pt-3" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("h1", { staticClass: "carrier-h1 mr-3 border-bottom" }, [
            _c("button", {
              staticClass: "btn btn-back",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  _vm.$router.push("/carriers")
                }
              }
            }),
            _vm._v("\n          " + _vm._s(_vm.carrier.name) + "\n        ")
          ])
        ])
      ]),
      _vm._v(" "),
      _c("nav", [
        _c("div", { staticClass: "mb-4 nav nav-tabs nav-fill border-top" }, [
          _c(
            "div",
            {
              staticClass: "nav-item nav-link pointer",
              class: [_vm.step === "carriers-info" ? "active" : ""],
              on: {
                click: function($event) {
                  _vm.setStep("carriers-info")
                }
              }
            },
            [_vm._v("\n          Carrier information\n        ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "nav-item nav-link pointer",
              class: [_vm.step === "carriers-availability" ? "active" : ""],
              on: {
                click: function($event) {
                  _vm.setStep("carriers-availability")
                }
              }
            },
            [_vm._v("\n          Availability\n        ")]
          ),
          _vm._v(" "),
          _vm.$_can("carriers.logs.index")
            ? _c(
                "div",
                {
                  staticClass: "nav-item nav-link pointer",
                  class: [_vm.step === "carriers-logs" ? "active" : ""],
                  on: {
                    click: function($event) {
                      _vm.setStep("carriers-logs")
                    }
                  }
                },
                [_vm._v("\n          Logs\n        ")]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "l-bg-white" }, [
        _vm.step === "carriers-info"
          ? _c(
              "div",
              [
                _c("carriers-info", {
                  attrs: { carrier: _vm.carrier },
                  on: { updated: _vm.getCarrier }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.step === "carriers-availability"
          ? _c(
              "div",
              [
                _c("carriers-availability", {
                  attrs: { carrier: _vm.carrier },
                  on: { updated: _vm.getCarrier }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.step === "carriers-logs"
          ? _c(
              "div",
              [_c("carriers-logs", { attrs: { carrier: _vm.carrier } })],
              1
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4eb70c0e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eb70c0e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/carriers/CarriersEdit.vue
// module id = null
// module chunks = 